export const THEME_SECONDARY_COLOR="#212121";
export const THEME_PRIMARY_COLOR="#FFFFFF";
export const THEME_TERTIARY_COLOR="#EA80FC";
export const SIMPLE_DATE_FORMAT="YYYY-MM-DD";
export const API_HOST = process.env.NODE_ENV === "production" ?
    "https://api.filioplan.com" : "http://localhost:8080";
export const OVERLAY_Z_INDEX=1000;
export const BACKGROUND_COLOR = "#222222";
